import { render, staticRenderFns } from "./DashboardText.vue?vue&type=template&id=78a670cb&scoped=true&"
import script from "./DashboardText.vue?vue&type=script&lang=js&"
export * from "./DashboardText.vue?vue&type=script&lang=js&"
import style0 from "./DashboardText.vue?vue&type=style&index=0&id=78a670cb&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "78a670cb",
  null
  
)

export default component.exports